import store from '@/packages/vuex'
import { createNamespacedHelpers } from 'vuex'
import Notification from './index.js'

if (!store?.state?.['Notification']) {
	store.registerModule('Notification', Notification)
}

export const { mapActions, mapGetters, mapMutations, mapState } = createNamespacedHelpers('Notification')
